import { render, staticRenderFns } from "./slides-item.vue?vue&type=template&id=3e562d20&scoped=true&"
import script from "./slides-item.vue?vue&type=script&lang=js&"
export * from "./slides-item.vue?vue&type=script&lang=js&"
import style0 from "./slides-item.vue?vue&type=style&index=0&id=3e562d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e562d20",
  null
  
)

export default component.exports